import { updateContentDecisionAction } from "./actions/updateContentDecisionAction.ts";
import PurchaseOptions from "./purchase-options";
import MyCart from "./my-cart";
import MyCourses from "./index";
import MyCoursesLayout from "./layout/MyCoursesLayout";
import { fetchAccessCodeAction } from "./actions/fetchAccessCodeAction.ts";
import { loadMyCoursesLayout } from "./layout/myCoursesLayoutLoader";
import { loadPurchaseOptions } from "./purchase-options/purchaseOptionsLoader";
import { loadCourses } from "./index/coursesLoader";
import { updateProgramChoiceAction } from "./actions/updateProgramChoiceAction.ts";
import { updateCartAction } from "./actions/updateCartAction.ts";
import { HomeRouteHandle } from "../homeRouteHandle.ts";
import { ShouldRevalidateFunctionArgs } from "react-router-dom";
import { myCartLoader } from "./my-cart/myCartLoader.ts";
import MyCoursesError from "./MyCoursesError.tsx";
import { contentAccessAction } from "./actions/contentAccessAction.ts";
import { storeMultiCartAction } from "./actions/storeMultiCartAction.ts";

const base = "/my-courses";

const myCoursesRoutes = {
  path: `${base}`,
  element: <MyCoursesLayout />,
  loader: loadMyCoursesLayout,
  errorElement: <MyCoursesError />,
  id: "courses-root",
  shouldRevalidate: ({ formAction }: ShouldRevalidateFunctionArgs) => {
    // do not revalidate on navigation
    return !!formAction;
  },
  children: [
    {
      index: true,
      loader: loadCourses,
      element: <MyCourses />,
      shouldRevalidate: ({
        formAction,
        defaultShouldRevalidate,
      }: ShouldRevalidateFunctionArgs) => {
        // virtual store actions don't affect course data
        if (
          formAction?.includes(`${base}/products`) ||
          formAction?.includes(`${base}/store-multi-cart`)
        ) {
          return false;
        }
        // content access actions don't affect course data
        if (formAction?.includes(`${base}/content-access`)) {
          return false;
        }
        return defaultShouldRevalidate;
      },
    },
    {
      path: `${base}/purchase-options/:termId/:courseId/:isbn`,
      loader: loadPurchaseOptions,
      element: <PurchaseOptions />,
    },
    {
      path: `${base}/my-cart`,
      element: <MyCart />,
      handle: { sidebar: false } as HomeRouteHandle,
      loader: myCartLoader,
    },
    {
      path: `${base}/access-code`,
      action: fetchAccessCodeAction,
    },
    {
      path: `${base}/content-decision`,
      action: updateContentDecisionAction,
    },
    {
      path: `${base}/content-access`,
      action: contentAccessAction,
    },
    {
      path: `${base}/program-decision`,
      action: updateProgramChoiceAction,
    },
    {
      path: `${base}/update-cart`,
      action: updateCartAction,
    },
    // virtual store actions
    {
      path: `${base}/store-multi-cart`,
      action: storeMultiCartAction,
    },
  ],
};

export default myCoursesRoutes;
